<template>
	<LayoutOffcanvasStandard ref="offcanvas" :title="title" :id="id">
		<template #body>
			<slot />
		</template>
		<template #footer>
			<button type="button" class="btn btn-primary rounded-pill w-100" @click="success">Aplicar filtros</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref } from 'vue';

	export default {
		emits: ['success'],
		props: {
			target: Object,
			title: {
				type: String,
				default: 'Más filtros'
			},
			id: {
				type: String,
				default: 'common-modal-filter'
			}
		},
		setup(props, { emit }) {
			const offcanvas = ref(null);

			const success = () => {
				emit('success', props.target);
				offcanvas.value.offcanvas.hide();
			}

			const show = () => offcanvas.value.offcanvas.show();

			return { offcanvas, success, show };
		}
	}
</script>